class Error {
  constructor(loginContainer, errorSelector) {
    this._loginContainer = loginContainer;
    this._errorElement = this._loginContainer.querySelector(errorSelector);
  }

  isShowedError() {
    return this._loginContainer.classList.contains(`login__content--show-error`)
  }

  showError(text) {
    this._loginContainer.classList.add(`login__content--show-error`);
    this._errorElement.innerHTML = text;
  }

  hideError() {
    this._loginContainer.classList.remove(`login__content--show-error`);
  }
}

export default Error;
